// LocationPosts.js  

import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LooksPostsContext } from '../contexts/LooksPostsContext';
import LooksPost from './LooksPost';
import { Typography } from '@mui/material';
import './UsersPosts.css';

const LocationPosts = () => {
  const { location } = useParams();
  const { posts } = useContext(LooksPostsContext);
  const [locationPosts, setLocationPosts] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (location && posts.length) {
      const filtered = posts.filter(
        (p) =>
          p.location === location &&
          !p.deleted &&
          !p.isReported &&
          (p.showOnHomePage || p.showInDiscoverBox)
      );
      setLocationPosts(filtered);
    }
  }, [location, posts]);

  return (
    <div className="users-posts-container">
      <h1>
        <span className="location-link">{location}</span>
      </h1>

      {locationPosts.length ? (
        locationPosts.map((post) => <LooksPost key={post.id} {...post} />)
      ) : (
        <Typography variant="body1" color="text.secondary">
          No posts found in this location.
        </Typography>
      )}
    </div>
  );
};

export default LocationPosts;

